<template>
  <sp-text class="sp-footnote" :type="type">
    <slot />
  </sp-text>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  /**
   * Designates the weight of the text.
   *
   * @type {String}
   * @default undefined
   * @values medium, bold
   */
  weight: {
    type: String,
    default: undefined,
    validator: (value) => ["medium", "bold"].includes(value),
  },
});

const type = computed(() => ["footnote", props.weight].filter(Boolean).join("-"));
</script>

<style>
:host {
  display: block;
  margin: 0;
}
</style>
